import { Box, Typography, useTheme } from "@mui/material";
import React from "react";
import InprogressTicket from "../../../../../../media/images/icons/inprogressTicketIcon.svg";
import { Link } from "react-router-dom";
import ArrowTickLeft from "../../../../../../media/images/icons/arrow-tick-left";
import CustomBadge from "../../../../../components/CustomBadge";
export default function TicketCard() {
  const theme = useTheme();

  return (
    <Box
      sx={{
        // height: "50px",
        borderRadius: "16px",
        boxShadow: "0px 2px 8px 0px rgba(0,0,0,0.1)",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        padding: "10px 8px",
      }}
    >
      <Box sx={{ display: "flex", alignItems: "center", gap: "8px" }}>
        <img src={InprogressTicket} alt="" />
        <Typography sx={{ fontWeight: "600" }}>بخشی از عنوان تیکت</Typography>
      </Box>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: "4px",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: "4px",
          }}
        >
          <CustomBadge status="inprogress" text="درحال انجام" size="small" />
          <Typography
            sx={{
              fontWeight: "600",
              fontSize: "12px",
            }}
          >
            25 دی 1402
          </Typography>
        </Box>
        <Link
          to={"#"}
          style={{
            display: "flex",
            alignItems: "center",
            // border: "1px solid gray",
            borderRadius: "8px",
            padding: "8px",
            backgroundColor: theme.palette.primary.main,
          }}
        >
          <Typography sx={{ color: "#ffffff" }}>مشاهده</Typography>
          <ArrowTickLeft size={16} color="#ffffff" />
        </Link>
      </Box>
    </Box>
  );
}
